module.exports = __webpack_public_path__ + "img/dash-receipt.1e7515ed.svg";